export default {
    brands_main_id: 'Id',
    brands_main_name: 'Title',
    brands_main_email: 'Email',
    brands_main_username: 'Username',
    brands_main_companies: 'Companies',
    brands_main_brands: 'Brands',
    brands_main_master_company_name: 'Master Company',
    brands_main_apply: 'Apply',
    brands_main_tags: 'Tags',
    brands_main_active_brands_only: 'Active Accounts Only',
    brands_main_yes: 'Yes',
    brands_main_no: 'No',
    brands_main_authenticate_cloud: 'Login as Customer',
    brands_main_re_sync_backend_information: 'Re-sync Backend Information',
    brands_main_devices: 'Devices',
    brands_main_package: 'Package',
    brands_main_crm: 'Salesforce Id',
    brands_main_add_dealer: 'Add Dealer',
    brands_main_edit: 'Edit',
    brands_main_remove_filters: 'Remove filters',
    brands_main_account_details: 'Account Details',
    brands_main_import_from_p4: 'Import From P4',
    brands_main_reprocess_odo_hours: 'Reprocess Odo/Hrs',
    brands_main_new_status: 'New Status',
    brands_main_at: 'at',
    brands_main_next_scheduled_action: 'Next scheduled action on',
    brands_main_on: 'on',
    brands_main_brand: 'Brand',
    brand_overview_tab_messages_templates: 'Messages Templates',
    brand_overview_tab_dealers: 'Dealers',
    brands_main_domains: 'Domains',
    brands_main_code: 'Code',
    brands_main_home_page: 'Home Page',
    brands_main_tos_url: 'Terms of Service URL',
    brands_main_help_url: 'Help URL',
    brands_main_address: 'Address',
    brands_main_phone: 'Phone',
    brands_main_login_background_image: 'Login Background Image',
    brands_main_login_background_color: 'Login Background Color',
    brands_main_login_company_logo: 'Login Company Logo',
    brands_main_favicon: 'Favicon',
    brands_main_navigate_to_test_page: 'Navigate to Test Page',
    brands_main_add_brand: 'Add Brand',
    brands_main_delete_brand: 'Delete Brand',
    brands_main_in_app_logo: 'In-App Logo',
};



